angular.module('CarsSaraBo').directive('reviewsSummaryDirective', ['ReviewsService', function (reviewsService) {
	return {
		scope: {
			summary: '=',
			isGlobal: '='
		},

		link: function (scope) {
			scope.getEvaluationClass = function (param) {
				return reviewsService.getEvaluationClass(param);
			},

			scope.getScoreClass = function (param) {
				return reviewsService.getScoreClass(param);
			}
		},

		templateUrl: 'assets/reviews/reviews-summary.html'
	};
}]);


//////////////////
// WEBPACK FOOTER
// ./public/app/models/directives/review_summary_directive.js
// module id = 886
// module chunks = 3